import React from 'react'
import {QRCodeCanvas} from 'qrcode.react';


function WailtListQRCode(props) {
    const {width, value} = props;
  return (
    <div style={{ height: "auto", margin: "0 auto", maxWidth: width, width: "100%" }}>
        <QRCodeCanvas
          value={typeof value === 'string' ? value : value.id}
          level='H'
          size={198}
        />
        <p className='pt_10'><span className="common_waitlist_normal_text">Pass :</span> <span className="common_waitlist_bold_text">{value.type === "user_pass" ? 'User Pass' : 'Waitlist Badge'}</span></p>
    </div>
  )
}


export default WailtListQRCode